export default "__VITE_ASSET__e9sydPnJ__"